"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styled_components_1 = __importStar(require("../Themes/styled-components"));
var utilities_1 = require("../Themes/utilities");
var Icon_1 = __importDefault(require("../Icon"));
var siteUrl_1 = __importDefault(require("./siteUrl"));
var EventStack_1 = __importDefault(require("../EventStack"));
var MediaManagerImage_1 = __importDefault(require("../MediaManagerImage"));
var react_collapse_1 = require("react-collapse");
var linkClass = 'responsive-menu-link';
var WIDTH_RESPONSIVE_MENU = 290;
var WrapperRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var WrapperSection = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n"], ["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: flex;\n"])));
var Overlay = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: fixed;\n  z-index: 121;\n  overflow-y: auto;\n\n  -webkit-overflow-scrolling: touch;\n  flex-wrap: wrap;\n  display: flex;\n  top: 0;\n  transition: all 0.35s;\n  ", "\n  width: 85%;\n  height: 100%;\n  background: ", ";\n  ", " {\n    ", "\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"], ["\n  position: fixed;\n  z-index: 121;\n  overflow-y: auto;\n\n  -webkit-overflow-scrolling: touch;\n  flex-wrap: wrap;\n  display: flex;\n  top: 0;\n  transition: all 0.35s;\n  ",
    "\n  width: 85%;\n  height: 100%;\n  background: ", ";\n  ", " {\n    ",
    "\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), function (_a) {
    var position = _a.position, visible = _a.visible;
    if (position === 'left') {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        left: ", ";\n      "], ["\n        left: ", ";\n      "])), visible ? '0%' : '-100%');
    }
    else {
        return styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        right: ", ";\n      "], ["\n        right: ", ";\n      "])), visible ? '0%' : '-100%');
    }
}, function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.backgroundColor;
}, utilities_1.mb('xs'), function (_a) {
    var visible = _a.visible;
    return visible && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        width: ", ";\n      "], ["\n        width: ", ";\n      "])), polished_1.rem(WIDTH_RESPONSIVE_MENU));
});
var CloseButtonContainer = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 50px;\n  width: 85%;\n"], ["\n  height: 50px;\n  width: 85%;\n"])));
var CloseButtonFixed = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  padding: ", " ", ";\n  position: fixed;\n  width: 85%;\n  ", " {\n    width: ", ";\n  }\n  background: ", ";\n"], ["\n  padding: ", " ", ";\n  position: fixed;\n  width: 85%;\n  ", " {\n    width: ", ";\n  }\n  background: ", ";\n"])), polished_1.rem(10), polished_1.rem(13), utilities_1.mb('xs'), polished_1.rem(WIDTH_RESPONSIVE_MENU), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.backgroundColor;
});
var CloseButton = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  width: ", ";\n  ", "\n"], ["\n  width: ", ";\n  ",
    "\n"])), polished_1.rem(50), function (_a) {
    var position = _a.position;
    if (position === 'right') {
        return styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n        margin-left: auto;\n        width: ", ";\n        display: block;\n      "], ["\n        margin-left: auto;\n        width: ", ";\n        display: block;\n      "])), polished_1.rem(26));
    }
    else {
        return styled_components_1.css(templateObject_10 || (templateObject_10 = __makeTemplateObject([""], [""])));
    }
});
var CloseIcon = styled_components_1.default(Icon_1.default)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var SIcon = styled_components_1.default(CloseIcon)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var ContentWrapper = styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: 100%;\n  .", " {\n    width: 100%;\n    padding: 0;\n    border: none;\n    font: inherit;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    padding: ", ";\n    padding-left: ", ";\n    font-size: ", ";\n    color: ", ";\n    font-weight: normal;\n    text-decoration: none;\n    outline: none;\n    align-items: center;\n  }\n\n  /* level 1 */\n  & > ul {\n    margin-top: 0;\n    margin: 0;\n    & > li {\n      & > .", " {\n        height: ", ";\n        display: flex;\n        align-items: center;\n        font-size: ", ";\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n      & > div > .", " {\n        height: ", ";\n        display: flex;\n        align-items: center;\n        font-size: ", ";\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  /* level 2 */\n  & > ul > li > div > div > ul {\n    background: ", ";\n    & > li > div > div > ul {\n      margin: 0;\n      background: ", ";\n    }\n    & > li > .", " {\n      font-size: ", ";\n      font-weight: bold;\n      color: ", ";\n    }\n    & > li > div > .", " {\n      font-size: ", ";\n      font-weight: bold;\n      color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  .", " {\n    width: 100%;\n    padding: 0;\n    border: none;\n    font: inherit;\n    background: none;\n    cursor: pointer;\n    display: flex;\n    padding: ", ";\n    padding-left: ", ";\n    font-size: ", ";\n    color: ", ";\n    font-weight: normal;\n    text-decoration: none;\n    outline: none;\n    align-items: center;\n  }\n\n  /* level 1 */\n  & > ul {\n    margin-top: 0;\n    margin: 0;\n    & > li {\n      & > .", " {\n        height: ", ";\n        display: flex;\n        align-items: center;\n        font-size: ", ";\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n      & > div > .", " {\n        height: ", ";\n        display: flex;\n        align-items: center;\n        font-size: ", ";\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n    }\n  }\n\n  /* level 2 */\n  & > ul > li > div > div > ul {\n    background: ",
    ";\n    & > li > div > div > ul {\n      margin: 0;\n      background: ",
    ";\n    }\n    & > li > .", " {\n      font-size: ", ";\n      font-weight: bold;\n      color: ", ";\n    }\n    & > li > div > .", " {\n      font-size: ", ";\n      font-weight: bold;\n      color: ", ";\n    }\n  }\n"])), linkClass, polished_1.rem(10), polished_1.rem(13), polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.linkColor;
}, linkClass, polished_1.rem(40), polished_1.rem(14), linkClass, polished_1.rem(40), polished_1.rem(14), function (_a) {
    var theme = _a.theme;
    return utilities_1.emphasizeColor(0.02, "" + theme.responsiveMenu.backgroundColor);
}, function (_a) {
    var theme = _a.theme;
    return utilities_1.emphasizeColor(0.06, "" + theme.responsiveMenu.backgroundColor);
}, linkClass, polished_1.rem(13), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.linkColorHighlighted;
}, linkClass, polished_1.rem(13), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.linkColorHighlighted;
});
var ListWrapper = styled_components_1.default.ul(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  display: block;\n  padding: 0;\n  margin: 0;\n  & > {\n    :focus,\n    :hover {\n      background: ", ";\n    }\n  }\n"], ["\n  display: block;\n  padding: 0;\n  margin: 0;\n  & > {\n    :focus,\n    :hover {\n      background: ",
    ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return utilities_1.emphasizeColor(0.09, "" + theme.responsiveMenu.backgroundColor);
});
var List = styled_components_1.default.li(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  list-style-type: none;\n  font-weight: bold;\n  font-size: ", ";\n"], ["\n  list-style-type: none;\n  font-weight: bold;\n  font-size: ", ";\n"])), polished_1.rem(14));
var SidebarBackdrop = styled_components_1.default('div')(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 120;\n  transition: all 0.35s;\n  background-color: ", ";\n  ", "\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 120;\n  transition: all 0.35s;\n  background-color: ", ";\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.responsiveMenu.backdropColor;
}, function (_a) {
    var isOpen = _a.isOpen;
    if (isOpen) {
        return styled_components_1.css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n        opacity: 1;\n      "], ["\n        opacity: 1;\n      "])));
    }
    else {
        return styled_components_1.css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n        pointer-events: none;\n        opacity: 0;\n      "], ["\n        pointer-events: none;\n        opacity: 0;\n      "])));
    }
});
var StyledMediaManagerImage = styled_components_1.default(MediaManagerImage_1.default)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  width: 24px;\n  flex-shrink: 0;\n  margin-right: 13px;\n"], ["\n  width: 24px;\n  flex-shrink: 0;\n  margin-right: 13px;\n"])));
var bodyOverflowHiddenClass = 'responsive-menu-opened';
var defaultProps = {
    depthLevel: 3,
    position: 'right',
};
var element = null;
var menuRoot;
if (typeof document !== 'undefined') {
    element = document.createElement('div');
    element.setAttribute('id', 'menu-root');
    menuRoot = document.body.appendChild(element);
}
var GlobalStyle = styled_components_1.createGlobalStyle(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\nbody.", " {\noverflow: hidden;\n}\n"], ["\nbody.", " {\noverflow: hidden;\n}\n"])), bodyOverflowHiddenClass);
var ResponsiveMenu = /** @class */ (function (_super) {
    __extends(ResponsiveMenu, _super);
    function ResponsiveMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.init = function () {
            document.body.classList.add(bodyOverflowHiddenClass);
            if (typeof document !== 'undefined') {
                EventStack_1.default.add(document.body, 'keydown', _this.handleKeyDown);
            }
        };
        _this.destroy = function () {
            document.body.classList.remove(bodyOverflowHiddenClass);
            if (typeof document !== 'undefined') {
                EventStack_1.default.remove(document.body, 'keydown', _this.handleKeyDown);
            }
        };
        _this.handleKeyDown = function (e) {
            var onClose = _this.props.onClose;
            if (e.key === 'Escape') {
                onClose();
            }
        };
        _this.handeleCollapse = function (id) {
            if (_this.state.openedSubmenuIdx.includes(id)) {
                var newOpenedSubmenuIdx = __spreadArrays(_this.state.openedSubmenuIdx);
                var index = newOpenedSubmenuIdx.indexOf(id);
                if (index !== -1) {
                    newOpenedSubmenuIdx.splice(index, 1);
                    _this.setState({ openedSubmenuIdx: newOpenedSubmenuIdx });
                }
            }
            else {
                _this.setState({
                    openedSubmenuIdx: __spreadArrays(_this.state.openedSubmenuIdx, [id]),
                });
            }
        };
        _this.itemRenderer = function (section, level, color) {
            var _a = _this.props, depthLevel = _a.depthLevel, renderLink = _a.renderLink, onClickLink = _a.onClickLink, onClose = _a.onClose;
            var linkChildren = (React.createElement(React.Fragment, null,
                section.icon && (React.createElement(StyledMediaManagerImage, { picture: section.icon, naturalHeight: 24, naturalWidth: 24 })),
                React.createElement(WrapperSection, null, section.name)));
            var linkChildrenWoIcon = React.createElement(WrapperSection, null, section.name);
            return (React.createElement(List, { key: String(section._id) },
                !section.sections ||
                    section.sections.length === 0 ||
                    level === depthLevel ? (renderLink ? (renderLink({
                    section: section,
                    linkProps: {
                        className: linkClass,
                        onClick: onClose,
                        children: linkChildren,
                    },
                    level: level,
                })) : onClickLink ? (React.createElement("button", { className: linkClass, onClick: function () { return onClickLink(section); } }, linkChildren)) : (React.createElement("span", { className: linkClass }, linkChildren))) : (React.createElement(WrapperRow, { onClick: function () {
                        _this.handeleCollapse(section._id);
                    } },
                    React.createElement("button", { className: linkClass }, linkChildren),
                    _this.state.openedSubmenuIdx.includes(section._id) ? (React.createElement(SIcon, { name: "arrow-down", color: color })) : (React.createElement(SIcon, { name: "arrow-right", color: color })))),
                section.sections &&
                    section.sections.length > 0 &&
                    level < depthLevel && (React.createElement(react_collapse_1.UnmountClosed, { isOpened: _this.state.openedSubmenuIdx.includes(section._id), hasNestedCollapse: true },
                    React.createElement(ListWrapper, null,
                        renderLink
                            ? renderLink({
                                section: section,
                                linkProps: {
                                    className: linkClass,
                                    onClick: onClose,
                                    children: linkChildrenWoIcon,
                                },
                                level: level,
                            })
                            : onClickLink && (React.createElement("button", { className: linkClass, onClick: function () { return onClickLink(section); } }, linkChildren)),
                        section.sections.map(function (item) {
                            return _this.itemRenderer(item, level + 1, color);
                        }))))));
        };
        _this.state = {
            active: false,
            openedSubmenuIdx: [],
        };
        return _this;
    }
    ResponsiveMenu.prototype.componentDidMount = function () {
        this.setState({ active: true });
        if (this.props.visible === true) {
            this.init();
        }
    };
    ResponsiveMenu.prototype.componentDidUpdate = function (prevProps) {
        var visible = this.props.visible;
        if (typeof document !== 'undefined') {
            if (visible === true && prevProps.visible === false) {
                this.init();
            }
            if (visible === false && prevProps.visible === true) {
                this.destroy();
            }
        }
    };
    ResponsiveMenu.prototype.componentWillUnmount = function () {
        this.destroy();
    };
    ResponsiveMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, visible = _a.visible, onClose = _a.onClose, sections = _a.sections, siteUrl = _a.siteUrl, theme = _a.theme, position = _a.position;
        var active = this.state.active;
        if (!active) {
            // portals are not supported serverside
            // whole point of "active" is, that when this component gets
            // server-rendered, it throws a nasty error about invalid
            // target element for rendering
            // it's hacky, but it works
            return null;
        }
        return react_dom_1.default.createPortal(React.createElement(React.Fragment, null,
            React.createElement(SidebarBackdrop, { isOpen: visible, onClick: onClose }),
            React.createElement(Overlay, { visible: visible, position: position },
                React.createElement(ContentWrapper, null,
                    React.createElement(CloseButtonContainer, null,
                        React.createElement(CloseButtonFixed, null,
                            React.createElement(CloseButton, { onClick: onClose, position: position },
                                React.createElement(CloseIcon, { size: 26, name: "close", color: theme.responsiveMenu.closeButtonColor || '#fff' })))),
                    React.createElement(ListWrapper, null, sections.map(function (item) {
                        return _this.itemRenderer(item, 1, theme.responsiveMenu.linkColor);
                    }))),
                siteUrl && React.createElement(siteUrl_1.default, { siteUrl: siteUrl })),
            React.createElement(GlobalStyle, null)), menuRoot);
    };
    ResponsiveMenu.defaultProps = defaultProps;
    return ResponsiveMenu;
}(React.PureComponent));
exports.ResponsiveMenu = ResponsiveMenu;
exports.default = styled_components_1.withTheme(ResponsiveMenu);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;
